module.exports = __webpack_public_path__ + "img/11.24b3fed.png";